import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetTimeToGetPaidQuery } from "../../../services/Reports";
import {
  getTimeToGetPaidRequest,
  getTimeToGetPaidFailure,
  getTimeToGetPaidSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allTimeToGetPaid,
    isLoading: timeToGetPaidLoading,
    isError: timeToGetPaidError,
  } = useGetTimeToGetPaidQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.timeToGetPaidPageNo,
    pageSize: state.timeToGetPaidPageSize,
    fromDate: new Date(state.timeToGetPaidFromDate).toLocaleDateString(),
    toDate: new Date(state.timeToGetPaidToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (timeToGetPaidLoading) {
      dispatch(getTimeToGetPaidRequest());
    }
    if (timeToGetPaidError) {
      dispatch(getTimeToGetPaidFailure(timeToGetPaidError));
    }
    if (allTimeToGetPaid) {
      dispatch(
        getTimeToGetPaidSuccess({
          data: allTimeToGetPaid.data.timeToGetPaid[0].data || [],
          totalPages:
            allTimeToGetPaid.data.timeToGetPaid[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allTimeToGetPaid,
    profileData,
    state.timeToGetPaidFromDate,
    state.timeToGetPaidToDate,
    state.timeToGetPaidPageNo,
    state.timeToGetPaidPageSize,
  ]);
  return <></>;
};
export default Content;
